import {
	FacebookShareButton,
	TwitterShareButton,
	WhatsappShareButton,
	LinkedinShareButton
} from "next-share";
import React from "react";

import { copyToClipboard } from "_common/utils/clientSide";
import Icon                from "_components/atoms/icon/container";
import useStyles           from "_styles/pages/blogs/shareComponent";

const ShareComponent = ( { post } ) => {
	const { slug, postId } = post;
	const { classes }      = useStyles ( undefined, { name: "styles" } );

	const shareLink = `https://www.rooter.gg/blogs/${ slug }/${ postId }`;

	return (
		<div className = { classes.shareComponentContainer }>
			<div className = { classes.svgContainer }
				onClick       = { () => copyToClipboard ( shareLink ) }
			>
				<Icon
					className = { classes.shareSvg }
					name      = "linkIcon"
				/>
			</div>

			<TwitterShareButton
				blankTarget = { true }
				url         = { shareLink }
			>

				<div className = { classes.svgContainer }>
					<Icon
						className = { classes.shareSvg }
						name      = "twitterRounded"
					/>
				</div>

			</TwitterShareButton>

			<FacebookShareButton
				blankTarget = { true }
				url         = { shareLink }
			>
				<div className = { classes.svgContainer }>
					<Icon
						className = { classes.shareSvg }
						name      = "facebookRounded"
					/>
				</div>
			</FacebookShareButton>

			<LinkedinShareButton
				blankTarget = { true }
				url         = { shareLink }
			>

				<div className = { classes.svgContainer }>
					<Icon
						className = { classes.shareSvg }
						name      = "linkedinRounded"
					/>
				</div>
			</LinkedinShareButton>

			<WhatsappShareButton
				blankTarget = { true }
				url         = { shareLink }
			>

				<div className = { classes.svgContainer }>
					<Icon
						className = { classes.shareSvg }
						name      = "whatsappRounded"
					/>
				</div>
			</WhatsappShareButton>

		</div>
	);
};

export default ShareComponent;
